import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const Collection7Video = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/lv5ag1gvlt`}
        maxHeight="80%"
      />
    </>
  );
};

export default Collection7Video;
